import { render, staticRenderFns } from "./SurveyQuestionEditorTextarea.vue?vue&type=template&id=0de0a3d7&"
import script from "./SurveyQuestionEditorTextarea.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionEditorTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports